import React from 'react';
import Teeshirt1 from '../../images/Teeshirt1.jpg';

const TeeshirtsContent = () => {
    return (
        <div className="category-content">
            <h3 className="content-title">Tee shirts</h3>
            <div className="product-grid">
                <div className="product-item">
                    <img src={Teeshirt1} alt="Tee shirt Gare de Troo" className="product-image teeshirt-image" />
                </div>
            </div>
        </div>
    );
};

export default TeeshirtsContent;
